var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 72,
    viewBox: "0 0 75 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#20016b",
    fillRule: "evenodd",
    d: "M11.12 4.607C8.413 10.666 5.012 16.069.723 21.205c-1.405 1.681 1.33 4.24 2.86 2.624.115-.123.219-.25.334-.372l.018-.02c3.23-3.477 5.891-7.162 8.032-11.187 2.417 32.146 30.918 53.927 61.835 59.139 1.237.207 1.362-1.676.179-1.926C43.897 63.108 15.656 40.39 15.687 7.81l13.57 15.216c1.684 1.89 4.57-.56 2.982-2.548L17.444 1.96c-.647-.81-1.51-.866-2.207-.52-.96-.975-2.802-.774-3.251.649-.27.855-.562 1.693-.867 2.519z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.90c6c6e6424fc49b84b4d298998ebd4a.svg";
export { ForwardRef as ReactComponent };